import { visit } from 'unist-util-visit';

const remarkWindowsPaths = () => {
    return (tree: any) => {
        visit(tree, 'link', (node: any) => {
            if (node.url && typeof node.url === 'string') {
                // Check if this is a Windows-style path
                if (node.url.match(/^[A-Za-z]:[\/\\]/)) {
                    // Store the original Windows path
                    node.properties = node.properties || {};
                    node.properties.windowsPath = node.url;

                    // Convert Windows path to URL-friendly format
                    node.url = node.url
                        .replace(/\\/g, '/') // Convert backslashes to forward slashes
                        .replace(/^[A-Za-z]:/, ''); // Remove drive letter completely
                }
            }
        });
    };
}

export default remarkWindowsPaths;